import { render, staticRenderFns } from "./ChapterDetailHeader.vue?vue&type=template&id=acd16bf6&scoped=true&"
import script from "./ChapterDetailHeader.vue?vue&type=script&lang=js&"
export * from "./ChapterDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChapterDetailHeader.vue?vue&type=style&index=0&id=acd16bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd16bf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VSkeletonLoader})
